import type { ConfigBundleViewModel } from "../types/viewmodel";

/**
 * Loads the server-side rendered data from the script tag injected by the Razor view
 */
export function loadServerData(): ConfigBundleViewModel | null {
	const serverDataElement = document.getElementById("server-data");
	if (!serverDataElement || !serverDataElement.textContent) {
		console.error("Server data not found in DOM");
		return null;
	}

	try {
		return JSON.parse(serverDataElement.textContent) as ConfigBundleViewModel;
	} catch (error) {
		console.error("Failed to parse server data:", error);
		return null;
	}
}